// extracted by mini-css-extract-plugin
export default {"selectedNameAutoComplete":"style_selectedNameAutoComplete__dFX-A","displayAlign":"style_displayAlign__Dpemk","input":"style_input__oWegP"};